import {createSelector} from 'reselect';
import {getSettings} from '../selectors';

export default createSelector(
  [getSettings],
  settings => !!(settings.should_hide_card),
);
